import React from 'react';
import { numericRegExp, TextFieldForm } from 'web-library';
import { OutlinedInputProps } from '@mui/material';
import {UseFormReturn} from "react-hook-form";

interface NumberOnlyFormItemProps {
  id?: string;
  className?: string;
  label?: string;
  title?: string;
  name: string;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  variant?: 'standard' | 'filled' | 'outlined';
  defaultValue?: any;
  /**
   * cannot use type="number", useForm watch will not work correctly
   */
  type?: string;
  placeholder?: string;
  startAdornment?: string;
  onChange?: (...args: any) => void;
  onBlur?: (...args: any) => void;
  isRequired?: boolean;
  isPasteDisabled?: boolean;
  inputProps?: OutlinedInputProps['inputProps'];
  shouldValidate?: boolean;
  form: UseFormReturn<any>;
}

/**
 * A component that doesn't allow entering of non-numeric character.
 * It uses useForm watch to remove non-numeric character.
 */
const NumberOnlyFormItem = ({
  id,
  className,
  label,
  title,
  name,
  disabled,
  error,
  helperText,
  fullWidth,
  size,
  variant,
  defaultValue,
  type,
  placeholder,
  startAdornment,
  onChange,
  onBlur,
  isRequired,
  isPasteDisabled,
  inputProps,
                              form,
  shouldValidate = true,
}: NumberOnlyFormItemProps) => (
  <TextFieldForm
    id={id}
    className={className}
    form={form}
    label={label}
    title={title}
    name={name}
    error={error}
    helperText={helperText}
    fullWidth={fullWidth}
    size={size}
    variant={variant}
    type={type}
    defaultValue={defaultValue}
    placeholder={placeholder}
    onChange={onChange}
    isPasteDisabled={isPasteDisabled}
    onBlur={onBlur}
    isRequired={isRequired}
    inputProps={{ ...inputProps, readOnly: disabled, startAdornment }}
    isInputTextFree={!shouldValidate}
    regExpToBlock={numericRegExp}
  />
);

export default NumberOnlyFormItem;
